import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { createConfig } from './app/app.config';
import { environment as defaults } from './environment';

import './open-telemetry/otel-instrument';
import './open-telemetry/otel-logging';

fetch('/api/status')
  .then(response => response.json())
  .then(({ features, configuration }) => {
    bootstrapApplication(
      AppComponent,
      createConfig(configuration.identity, {
        ...defaults.features,
        ...features,
      }),
    ).catch(err => console.error(err));
  });
